<template>
  <div class="category-input" :style="{ backgroundColor: backgroundColor}">
    <section class="category-content">
      <div class="input-section">
        <span
          class="input-annotation"
          :style="{ backgroundColor: color}"
        >{{ annotation }}</span>
        <InputText
          class="category-name"
          :val="category.value"
          :limit="CATEGORY_NAME_LENGTH"
          :placeHolder="$i18nPresenter.t('Enter category name')"
          @interface="changeCategoryName"
        />
      </div>
      <div
        class="delete-button"
        :class="{
          'cursor-pointer': removable,
          'cursor-not-allowed': !removable,
        }"
        @click="removable && $emit('remove-category', id)"
      >
        <i class="far fa-trash-alt" />
      </div>
    </section>
    <section class="category-options">
      <AhaInputTag
        :validator="validateInputTag"
        :allowDuplicate="false"
        :supportSpaces="true"
        :value="options"
        @input="changeCategoryOptions"
        :placeholder="optionInputPlaceholder"
      />
    </section>
  </div>
</template>
<script>
import InputText from '@/components/presentations/InputText'
import { CATEGORY_NAME_LENGTH, CATEGORY_OPTION_LENGTH } from '@/constant/Categorise.constant'

export default {
  components: {
    InputText,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: true,
    },
    annotation: {
      type: String,
      default: '',
    },
    removable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      CATEGORY_NAME_LENGTH,
    }
  },
  computed: {
    options() {
      if (!this.category.options) return []
      return this.category.options.map((o) => o.value)
    },
    optionInputPlaceholder() {
      if (this.options.length === 0) return this.$i18nPresenter.t('Enter options, separated by commas')
      return ''
    },
  },
  methods: {
    validateInputTag(value) {
      return value.trim().length <= CATEGORY_OPTION_LENGTH
    },
    changeCategoryName(updatedData) {
      this.$emit('category-update', {
        ...this.category,
        value: updatedData.value,
      })
    },
    changeCategoryOptions(items) {
      const options = items.map((value) => ({ value }))
      this.$emit('category-update', {
        ...this.category,
        options,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
 .category-input {
    --gap: 0.5rem;
    display: flex;
    padding: 0.5rem;
    gap: var(--gap);
    flex-direction: column;

    & > .category-options::v-deep {
        & .tag-input {
            background: white;
        }
    }

   & > .category-content {
        display: flex;
        gap: var(--gap);

        .category-name::v-deep {
            & input {
                padding-left: 35px;
            }
        }

        & > .delete-button {
            width: 44px;
        }

        .input-section {
            position: relative;
            width: 100%;
            .input-annotation {
                margin-left: 1px;
                position: absolute;
                left: 0;
                z-index: 1;
                color: white;
                border-radius: 2px 0 0 2px;
                font-weight: 700;
                height: 100%;
                width: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
 }
</style>
